/* eslint-disable class-methods-use-this */
import { PagedResult } from "@iventis/domain-model/model/pagedResult";
import { SearchResult } from "@iventis/domain-model/model/searchResult";
import { SavedMapView } from "@iventis/domain-model/model/savedMapView";
import { ReactNode } from "react";
import { AxiosInstance } from "axios";
import { SearchResultGroupInterface } from "../interface/search-result-interface";
import { SavedMapViewOptions, SearchResultType } from "../types/types";

export class SavedMapViewsSearchResult extends SearchResultGroupInterface<SavedMapView> {
    constructor(name: string, type: SearchResultType, icon: ReactNode, onResultClicked: (result: SavedMapView) => void, options: SavedMapViewOptions) {
        super(name, type, icon, onResultClicked);
        this.mapId = options.mapId;
        this.api = options.api;
    }

    private readonly mapId: string;

    private readonly api: AxiosInstance;

    public async getResults(searchString: string): Promise<{ type: SearchResultType; results: SearchResult<SavedMapView>[] }> {
        // As body is just a string we need to set the content type
        // Only ever want one page of results from the search as we only need to display three results
        const config = { headers: { "Content-Type": "application/json" }, params: { pageNumber: 1, pageSize: 3, mapId: this.mapId } };
        const response = await this.api.post<PagedResult<SearchResult<SavedMapView>[]>>(`/saved_map_views/search`, JSON.stringify(searchString), config);
        return { type: this.type, results: response.data.results };
    }
}
